/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Bag24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Bag 24">
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="M9 5c0-1.658 1.342-3 3-3s3 1.342 3 3H9ZM7 5c0-2.762 2.238-5 5-5s5 2.238 5 5h2.795a2 2 0 0 1 2 1.955l.2 8.822a2 2 0 0 0 .06.44l1.324 5.298A2 2 0 0 1 21.439 24H2.561a2 2 0 0 1-1.94-2.485l1.318-5.276a2 2 0 0 0 .06-.485V7a2 2 0 0 1 2-2h3Zm14.438 17H2.562l1.319-5.276a4 4 0 0 0 .119-.97V7h15.795l.2 8.822c.007.297.047.592.119.88L21.438 22Z"
        className="SVG"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath>
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

const SIZE_MAP = {
  sm: Bag24,
  md: Bag24,
  lg: Bag24,
  xl: Bag24,
  xxl: Bag24,
  xxxl: Bag24,
};

export const BagIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'bag-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
